import { memo } from 'react';
function SpottedTrailerMarker({ backgroundColor, borderColor }) {
  return (
    <svg width="29" height="32" viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3992_4139)">
        <path d="M24.78 18V6L14.39 0L4 6V18L14.39 24L24.78 18Z" fill={backgroundColor} />
        <path
          d="M14.39 1.15L23.78 6.57V17.42L14.39 22.84L5 17.42V6.58L14.39 1.15ZM14.39 0L4 6V18L14.39 24L24.78 18V6L14.39 0Z"
          fill={borderColor}
        />
        <path
          d="M19.1527 14.9573V10.3907V7.78125H10.0195C9.30186 7.78125 8.71472 8.36838 8.71472 9.08599V16.2621H10.0195C10.0195 17.345 10.8936 18.2192 11.9766 18.2192C13.0595 18.2192 13.9337 17.345 13.9337 16.2621H17.8479C17.8479 16.2621 18.7222 16.2621 19.8051 16.2621H21.1098V14.9573H19.1527ZM11.9766 16.9144C11.6178 16.9144 11.3242 16.6209 11.3242 16.2621C11.3242 15.9033 11.6178 15.6097 11.9766 15.6097C12.3354 15.6097 12.6289 15.9033 12.6289 16.2621C12.6289 16.6209 12.3354 16.9144 11.9766 16.9144ZM13.4248 14.9573C13.066 14.5594 12.5572 14.305 11.9766 14.305C11.396 14.305 10.8871 14.5594 10.5283 14.9573H10.0195V9.08599H17.8479V14.9573H13.4248Z"
          fill={borderColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3992_4139"
          x="-2"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity ="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3992_4139" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3992_4139"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(SpottedTrailerMarker);
